import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { useAlert } from "../../components/Alert";
import GenericButton from "../../components/Custom/GenericButton";
import api from "../../globals/axios";

const CreateActivity = () => {
  const { stageId, programId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const PRIORITY_OPTIONS = ["CRITICAL", "ADVISORY"];
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    start_day: "",
    end_day: "",
    priority: PRIORITY_OPTIONS[0], // Default to "CRITICAL"
    stage: stageId || "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/farm-activities/create-activity/", formData);
      showAlert("success", "Activity created successfully");
      navigate(`/pop-manager/program/${programId}/stage/${stageId}`);
    } catch (error) {
      console.error("Error Creating Activity", error);
      showAlert("error", t("Error creating Activity"));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Container
      maxWidth="xs"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <CustomTitle>{t("Create Activity")}</CustomTitle>
      <form
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        onSubmit={handleSubmit}
      >
        <TextField
          label={t("Activity Name")}
          variant="outlined"
          fullWidth
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder={t("Enter activity name")}
          required
        />
        <TextField
          label={t("Start Day")}
          type="number"
          name="start_day"
          value={formData.start_day}
          onChange={handleChange}
          required
        />
        <TextField
          label={t("End Day")}
          type="number"
          name="end_day"
          value={formData.end_day}
          onChange={handleChange}
          required
        />
        <TextField
          label={t("Description")}
          type="text"
          multiline
          rows={4}
          fullWidth
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
        />
        <FormControl sx={{ px: 2 }}>
          <RadioGroup
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            row
          >
            {PRIORITY_OPTIONS.map((option) => (
              <FormControlLabel
                key={option}
                value={option}
                control={<Radio color="success" />}
                label={option}
              />
            ))}
          </RadioGroup>
        </FormControl>
        <GenericButton
          type="submit"
          backgroundColor="primary"
          fontColor="#fff"
          padding="10px"
        >
          {t("Submit")}
        </GenericButton>
      </form>
    </Container>
  );
};

export default CreateActivity;
